class PasswordModal extends DetailsModal {
	constructor() {
		super();
		if (this.querySelector('input[aria-invalid="true"]'))
			this.open({ target: this.querySelector("details") }, "password");
	}

	onSummaryClick(event) {
		event.preventDefault();
		if (event.target.closest("details").hasAttribute("open") === true) {
			console.log("in here");
			this.close();
		} else {
			this.open(event, "password");
		}
	}
}

customElements.define("password-modal", PasswordModal);
